import { render } from "./payPaid.vue?vue&type=template&id=1c2ac1f0&scoped=true"
import script from "./payPaid.vue?vue&type=script&lang=js"
export * from "./payPaid.vue?vue&type=script&lang=js"

import "./payPaid.vue?vue&type=style&index=0&id=1c2ac1f0&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2ac1f0"]])

export default __exports__